import React from "react";
import { connect } from "react-redux";
import { setEditData, setModalTemplate, setModalType, setShowEditUnitOfMeasureModal } from '../../redux/modal/modal.actions';
import { createStructuredSelector } from 'reselect';
import { selectEditUUID, selectModalFormTemplate, selectShowEditUnitofMeasureModal } from "../../redux/modal/modal.reselect";
import { useEffect } from "react";

import EDIT_UNIT_OF_MEASURE_FORM_TEMPLATE from './edit-unit-of-measures.template';

import ModalContainer from "../modal/modal.container";
import useFetchEdit from "../../effects/use-fetch-edit.effect";
import { authTokenSelector } from "../../redux/user/user.reselect";

const EditUnitOfMeasure = ({
    showEditUnitOfMeasure,
    setModalTemplate,
    setModalType,
    formTemplate,
    editUUID,
    authToken,
    setShowEditUnitOfMeasureModal,
    isFetching,
    setEditData
}) => {
    useEffect(() => {
        setModalType("EDIT_UNIT_OF_MEASURE")
        setModalTemplate(EDIT_UNIT_OF_MEASURE_FORM_TEMPLATE);
    }, []);
    const endpoint = '/unitofmeasures';
    const endpointUrl = `${endpoint}/${editUUID}`;
    const authTokenFromState = authToken;

    const { data, error } = useFetchEdit(endpointUrl, authTokenFromState, showEditUnitOfMeasure);

    useEffect(() => {
        setEditData(data)
    })
    
    return (
        <div className="edit-unit-of-measures">
            {
                Object.keys(formTemplate).length > 0 ?
                    <ModalContainer
                        showModal={showEditUnitOfMeasure}
                        setShowModal={setShowEditUnitOfMeasureModal}
                        endpointUrl={endpointUrl}
                        size={"MEDIUM"}
                    />
                    : null
            }
        </div>
    )
}

const mapStateToProps = createStructuredSelector({
    showEditUnitOfMeasure: selectShowEditUnitofMeasureModal,
    formTemplate: selectModalFormTemplate,
    editUUID: selectEditUUID,
    authToken: authTokenSelector,
})

const mapDispatchToProps = (disptach) => ({
    setShowEditUnitOfMeasureModal: () =>
        disptach(setShowEditUnitOfMeasureModal()),
    setModalTemplate: (formTemplate) =>
        disptach(setModalTemplate(formTemplate)),
    setModalType: (modalType) =>
        disptach(setModalType(modalType)),
    setEditData: (editData) =>
        disptach(setEditData(editData))
})


export default connect(mapStateToProps, mapDispatchToProps)(EditUnitOfMeasure);